module.exports = __webpack_public_path__ + "img/email.9e71c63b.svg";